import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import getNotCompletedCompehension from '../../../../../utils/shared/probeDetailsUtils';
import RetellTable from './retellRecall/RetellTable';
import OralComprehensionTable from './oralComprehension/OralComprehensionTable';
import WrittenComprehensionTable from './writtenComprehension/WrittenComprehensionTable';

const Comprehension = ({ result, student, values }) => {
    const { rubricMapper, wcScoreList, retellRecallValues } = values;
    const { lastName, firstName } = student;
    const { trcScore, probeDetailResult, retellOrRecall } = result;
    const { oralCompResult, writtenCompIgnored, retellings } = probeDetailResult;
    const { writtenComprehensionResultGroup, retellScore, retellRecall, bookType, retelling } =
        trcScore;
    const isComprehensionNotCompleted =
        isNil(oralCompResult) && isNil(writtenComprehensionResultGroup) && isNil(retellScore);
    return (
        <div className="comprehension-paragraphs active">
            {isComprehensionNotCompleted ? (
                getNotCompletedCompehension(firstName, lastName)
            ) : (
                <>
                    <OralComprehensionTable
                        oralCompResult={oralCompResult}
                        rubricMapper={rubricMapper}
                    />
                    <WrittenComprehensionTable
                        resultGroup={writtenComprehensionResultGroup}
                        isIgnored={writtenCompIgnored}
                        scoreList={wcScoreList}
                    />
                    <RetellTable
                        retellScore={retellScore}
                        retellRecall={retellRecall}
                        retelling={retelling}
                        retellings={retellings}
                        retellOrRecall={retellOrRecall}
                        bookType={bookType}
                        values={retellRecallValues}
                    />
                </>
            )}
        </div>
    );
};

Comprehension.defaultProps = {
    result: {},
    student: {},
    values: {},
};

Comprehension.propTypes = {
    result: PropTypes.object,
    student: PropTypes.object,
    values: PropTypes.object,
};

export default Comprehension;
